export const opportunityStatusMap = {
  'Draft': 0,
  'Active': 1,
  'Expired': 2,
  'Delete': 3
}

export const changeOpportunityStatusMap = {
  0: [{ status: 'Active', class: 'badge badge-pill btn-success cursor-pointer' }],
  1: [{ status: 'Draft', class: 'badge badge-pill btn-warning' }],
  2: [{ status: 'Draft', class: 'badge badge-pill btn-warning' }]
}

export const RECURRENCE_TYPE = {
  ONE_TIME: 'ONETIME',
  RECURRING: 'RECURRING'
}

export const recurrenceOptions = [
  { value: RECURRENCE_TYPE.ONE_TIME, label: 'One time' },
  { value: RECURRENCE_TYPE.RECURRING, label: 'Recurring' }
]

export const splitOptions = [
  { value: 'EQUAL', label: 'Split Equally' },
  { value: 'MANUAL', label: 'Split Manually' }
]

export const OPPORTUNITY_TYPES = {
  IN_SESSION: 'IN_SESSION',
  OUT_OF_SESSION: 'OUT_OF_SESSION'
}

export const opportunityTypeOptions = [
  { value: OPPORTUNITY_TYPES.IN_SESSION, label: 'In Session (<24 hours)' },
  { value: OPPORTUNITY_TYPES.OUT_OF_SESSION, label: 'Out of Session (>=24 hours)' }
]

export const TOGGLE_COLUMN_TYPES = {
  REFERRALS: 'Referral Column Group'
}

export const maxOpportunityGroupsAllowed = 5

export const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']



// WEBPACK FOOTER //
// ./src/components/opportunity-management/constants.js